/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateHit = /* GraphQL */ `
  subscription OnCreateHit($serial: String) {
    onCreateHit(serial: $serial) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      lat
      lon
      score
      specSum
      version
      detectionArray
      detectionConfidence
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDevice = /* GraphQL */ `
  subscription OnCreateDevice(
    $filter: ModelSubscriptionDeviceFilterInput
    $owner: String
  ) {
    onCreateDevice(filter: $filter, owner: $owner) {
      id
      serial
      type
      version
      owner
      name
      privateAudio
      shareLink
      shareBird
      shareMarine
      hideOnMap
      collectSoundscape
      createdAt
      updatedAt
      lat
      lon
      tzOffsetMinutes
      tz
      smsPhone1
      smsPhone2
      smsTimeStart
      smsTimeStop
      smsPause
      newBirdAlert
      __typename
    }
  }
`;
export const onUpdateDevice = /* GraphQL */ `
  subscription OnUpdateDevice(
    $filter: ModelSubscriptionDeviceFilterInput
    $owner: String
  ) {
    onUpdateDevice(filter: $filter, owner: $owner) {
      id
      serial
      type
      version
      owner
      name
      privateAudio
      shareLink
      shareBird
      shareMarine
      hideOnMap
      collectSoundscape
      createdAt
      updatedAt
      lat
      lon
      tzOffsetMinutes
      tz
      smsPhone1
      smsPhone2
      smsTimeStart
      smsTimeStop
      smsPause
      newBirdAlert
      __typename
    }
  }
`;
export const onDeleteDevice = /* GraphQL */ `
  subscription OnDeleteDevice(
    $filter: ModelSubscriptionDeviceFilterInput
    $owner: String
  ) {
    onDeleteDevice(filter: $filter, owner: $owner) {
      id
      serial
      type
      version
      owner
      name
      privateAudio
      shareLink
      shareBird
      shareMarine
      hideOnMap
      collectSoundscape
      createdAt
      updatedAt
      lat
      lon
      tzOffsetMinutes
      tz
      smsPhone1
      smsPhone2
      smsTimeStart
      smsTimeStop
      smsPause
      newBirdAlert
      __typename
    }
  }
`;
export const onCreateDeviceHistory = /* GraphQL */ `
  subscription OnCreateDeviceHistory(
    $filter: ModelSubscriptionDeviceHistoryFilterInput
  ) {
    onCreateDeviceHistory(filter: $filter) {
      id
      serial
      version
      owner
      name
      shareBird
      createDate
      createdAt
      updatedAt
      lat
      lon
      deviceAction
      __typename
    }
  }
`;
export const onUpdateDeviceHistory = /* GraphQL */ `
  subscription OnUpdateDeviceHistory(
    $filter: ModelSubscriptionDeviceHistoryFilterInput
  ) {
    onUpdateDeviceHistory(filter: $filter) {
      id
      serial
      version
      owner
      name
      shareBird
      createDate
      createdAt
      updatedAt
      lat
      lon
      deviceAction
      __typename
    }
  }
`;
export const onDeleteDeviceHistory = /* GraphQL */ `
  subscription OnDeleteDeviceHistory(
    $filter: ModelSubscriptionDeviceHistoryFilterInput
  ) {
    onDeleteDeviceHistory(filter: $filter) {
      id
      serial
      version
      owner
      name
      shareBird
      createDate
      createdAt
      updatedAt
      lat
      lon
      deviceAction
      __typename
    }
  }
`;
export const onCreateDeviceState = /* GraphQL */ `
  subscription OnCreateDeviceState(
    $filter: ModelSubscriptionDeviceStateFilterInput
  ) {
    onCreateDeviceState(filter: $filter) {
      id
      serial
      type
      lat
      lon
      timezone
      connected
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDeviceState = /* GraphQL */ `
  subscription OnUpdateDeviceState(
    $filter: ModelSubscriptionDeviceStateFilterInput
  ) {
    onUpdateDeviceState(filter: $filter) {
      id
      serial
      type
      lat
      lon
      timezone
      connected
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDeviceState = /* GraphQL */ `
  subscription OnDeleteDeviceState(
    $filter: ModelSubscriptionDeviceStateFilterInput
  ) {
    onDeleteDeviceState(filter: $filter) {
      id
      serial
      type
      lat
      lon
      timezone
      connected
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBootTable = /* GraphQL */ `
  subscription OnCreateBootTable(
    $filter: ModelSubscriptionBootTableFilterInput
  ) {
    onCreateBootTable(filter: $filter) {
      id
      serial
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBootTable = /* GraphQL */ `
  subscription OnUpdateBootTable(
    $filter: ModelSubscriptionBootTableFilterInput
  ) {
    onUpdateBootTable(filter: $filter) {
      id
      serial
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBootTable = /* GraphQL */ `
  subscription OnDeleteBootTable(
    $filter: ModelSubscriptionBootTableFilterInput
  ) {
    onDeleteBootTable(filter: $filter) {
      id
      serial
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateStatusTable = /* GraphQL */ `
  subscription OnCreateStatusTable(
    $filter: ModelSubscriptionStatusTableFilterInput
  ) {
    onCreateStatusTable(filter: $filter) {
      id
      serial
      cpuTemp
      cpuFreq
      warning
      ramdisk
      signal
      availMem
      pyMem
      gridLength
      nDirect
      nCloud
      freeGB
      lat
      lon
      V
      ovf
      postTime
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateStatusTable = /* GraphQL */ `
  subscription OnUpdateStatusTable(
    $filter: ModelSubscriptionStatusTableFilterInput
  ) {
    onUpdateStatusTable(filter: $filter) {
      id
      serial
      cpuTemp
      cpuFreq
      warning
      ramdisk
      signal
      availMem
      pyMem
      gridLength
      nDirect
      nCloud
      freeGB
      lat
      lon
      V
      ovf
      postTime
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteStatusTable = /* GraphQL */ `
  subscription OnDeleteStatusTable(
    $filter: ModelSubscriptionStatusTableFilterInput
  ) {
    onDeleteStatusTable(filter: $filter) {
      id
      serial
      cpuTemp
      cpuFreq
      warning
      ramdisk
      signal
      availMem
      pyMem
      gridLength
      nDirect
      nCloud
      freeGB
      lat
      lon
      V
      ovf
      postTime
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLogTable = /* GraphQL */ `
  subscription OnCreateLogTable($filter: ModelSubscriptionLogTableFilterInput) {
    onCreateLogTable(filter: $filter) {
      id
      serial
      log
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLogTable = /* GraphQL */ `
  subscription OnUpdateLogTable($filter: ModelSubscriptionLogTableFilterInput) {
    onUpdateLogTable(filter: $filter) {
      id
      serial
      log
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLogTable = /* GraphQL */ `
  subscription OnDeleteLogTable($filter: ModelSubscriptionLogTableFilterInput) {
    onDeleteLogTable(filter: $filter) {
      id
      serial
      log
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateExceptionTable = /* GraphQL */ `
  subscription OnCreateExceptionTable(
    $filter: ModelSubscriptionExceptionTableFilterInput
  ) {
    onCreateExceptionTable(filter: $filter) {
      id
      serial
      exception
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateExceptionTable = /* GraphQL */ `
  subscription OnUpdateExceptionTable(
    $filter: ModelSubscriptionExceptionTableFilterInput
  ) {
    onUpdateExceptionTable(filter: $filter) {
      id
      serial
      exception
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteExceptionTable = /* GraphQL */ `
  subscription OnDeleteExceptionTable(
    $filter: ModelSubscriptionExceptionTableFilterInput
  ) {
    onDeleteExceptionTable(filter: $filter) {
      id
      serial
      exception
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDailyCount = /* GraphQL */ `
  subscription OnCreateDailyCount(
    $filter: ModelSubscriptionDailyCountFilterInput
  ) {
    onCreateDailyCount(filter: $filter) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDailyCount = /* GraphQL */ `
  subscription OnUpdateDailyCount(
    $filter: ModelSubscriptionDailyCountFilterInput
  ) {
    onUpdateDailyCount(filter: $filter) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDailyCount = /* GraphQL */ `
  subscription OnDeleteDailyCount(
    $filter: ModelSubscriptionDailyCountFilterInput
  ) {
    onDeleteDailyCount(filter: $filter) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLabeledData = /* GraphQL */ `
  subscription OnCreateLabeledData(
    $filter: ModelSubscriptionLabeledDataFilterInput
    $labeledBy: String
  ) {
    onCreateLabeledData(filter: $filter, labeledBy: $labeledBy) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      labeledBy
      label
      score
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLabeledData = /* GraphQL */ `
  subscription OnUpdateLabeledData(
    $filter: ModelSubscriptionLabeledDataFilterInput
    $labeledBy: String
  ) {
    onUpdateLabeledData(filter: $filter, labeledBy: $labeledBy) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      labeledBy
      label
      score
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLabeledData = /* GraphQL */ `
  subscription OnDeleteLabeledData(
    $filter: ModelSubscriptionLabeledDataFilterInput
    $labeledBy: String
  ) {
    onDeleteLabeledData(filter: $filter, labeledBy: $labeledBy) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      labeledBy
      label
      score
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRawHaikumarine = /* GraphQL */ `
  subscription OnCreateRawHaikumarine(
    $filter: ModelSubscriptionRawHaikumarineFilterInput
  ) {
    onCreateRawHaikumarine(filter: $filter) {
      id
      serial
      dt
      lat
      lon
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRawHaikumarine = /* GraphQL */ `
  subscription OnUpdateRawHaikumarine(
    $filter: ModelSubscriptionRawHaikumarineFilterInput
  ) {
    onUpdateRawHaikumarine(filter: $filter) {
      id
      serial
      dt
      lat
      lon
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRawHaikumarine = /* GraphQL */ `
  subscription OnDeleteRawHaikumarine(
    $filter: ModelSubscriptionRawHaikumarineFilterInput
  ) {
    onDeleteRawHaikumarine(filter: $filter) {
      id
      serial
      dt
      lat
      lon
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateNotifications = /* GraphQL */ `
  subscription OnCreateNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $owner: String
  ) {
    onCreateNotifications(filter: $filter, owner: $owner) {
      id
      serial
      owner
      played
      notificationType
      cn
      spCode
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateNotifications = /* GraphQL */ `
  subscription OnUpdateNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $owner: String
  ) {
    onUpdateNotifications(filter: $filter, owner: $owner) {
      id
      serial
      owner
      played
      notificationType
      cn
      spCode
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteNotifications = /* GraphQL */ `
  subscription OnDeleteNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $owner: String
  ) {
    onDeleteNotifications(filter: $filter, owner: $owner) {
      id
      serial
      owner
      played
      notificationType
      cn
      spCode
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateShareMap = /* GraphQL */ `
  subscription OnCreateShareMap(
    $filter: ModelSubscriptionShareMapFilterInput
    $owner: String
  ) {
    onCreateShareMap(filter: $filter, owner: $owner) {
      id
      name
      shareLat
      shareLon
      tz
      connected
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateShareMap = /* GraphQL */ `
  subscription OnUpdateShareMap(
    $filter: ModelSubscriptionShareMapFilterInput
    $owner: String
  ) {
    onUpdateShareMap(filter: $filter, owner: $owner) {
      id
      name
      shareLat
      shareLon
      tz
      connected
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteShareMap = /* GraphQL */ `
  subscription OnDeleteShareMap(
    $filter: ModelSubscriptionShareMapFilterInput
    $owner: String
  ) {
    onDeleteShareMap(filter: $filter, owner: $owner) {
      id
      name
      shareLat
      shareLon
      tz
      connected
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateHaikuboxUser = /* GraphQL */ `
  subscription OnCreateHaikuboxUser(
    $filter: ModelSubscriptionHaikuboxUserFilterInput
  ) {
    onCreateHaikuboxUser(filter: $filter) {
      id
      email
      confirmedEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateHaikuboxUser = /* GraphQL */ `
  subscription OnUpdateHaikuboxUser(
    $filter: ModelSubscriptionHaikuboxUserFilterInput
  ) {
    onUpdateHaikuboxUser(filter: $filter) {
      id
      email
      confirmedEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteHaikuboxUser = /* GraphQL */ `
  subscription OnDeleteHaikuboxUser(
    $filter: ModelSubscriptionHaikuboxUserFilterInput
  ) {
    onDeleteHaikuboxUser(filter: $filter) {
      id
      email
      confirmedEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBookmarkHaikubox = /* GraphQL */ `
  subscription OnCreateBookmarkHaikubox(
    $filter: ModelSubscriptionBookmarkHaikuboxFilterInput
    $owner: String
  ) {
    onCreateBookmarkHaikubox(filter: $filter, owner: $owner) {
      id
      serial
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBookmarkHaikubox = /* GraphQL */ `
  subscription OnUpdateBookmarkHaikubox(
    $filter: ModelSubscriptionBookmarkHaikuboxFilterInput
    $owner: String
  ) {
    onUpdateBookmarkHaikubox(filter: $filter, owner: $owner) {
      id
      serial
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBookmarkHaikubox = /* GraphQL */ `
  subscription OnDeleteBookmarkHaikubox(
    $filter: ModelSubscriptionBookmarkHaikuboxFilterInput
    $owner: String
  ) {
    onDeleteBookmarkHaikubox(filter: $filter, owner: $owner) {
      id
      serial
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUnclaimHaikubox = /* GraphQL */ `
  subscription OnCreateUnclaimHaikubox(
    $filter: ModelSubscriptionUnclaimHaikuboxFilterInput
    $owner: String
  ) {
    onCreateUnclaimHaikubox(filter: $filter, owner: $owner) {
      id
      serial
      owner
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUnclaimHaikubox = /* GraphQL */ `
  subscription OnUpdateUnclaimHaikubox(
    $filter: ModelSubscriptionUnclaimHaikuboxFilterInput
    $owner: String
  ) {
    onUpdateUnclaimHaikubox(filter: $filter, owner: $owner) {
      id
      serial
      owner
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUnclaimHaikubox = /* GraphQL */ `
  subscription OnDeleteUnclaimHaikubox(
    $filter: ModelSubscriptionUnclaimHaikuboxFilterInput
    $owner: String
  ) {
    onDeleteUnclaimHaikubox(filter: $filter, owner: $owner) {
      id
      serial
      owner
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserNotice = /* GraphQL */ `
  subscription OnCreateUserNotice(
    $filter: ModelSubscriptionUserNoticeFilterInput
    $owner: String
  ) {
    onCreateUserNotice(filter: $filter, owner: $owner) {
      id
      owner
      noticeID
      noticeViewed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserNotice = /* GraphQL */ `
  subscription OnUpdateUserNotice(
    $filter: ModelSubscriptionUserNoticeFilterInput
    $owner: String
  ) {
    onUpdateUserNotice(filter: $filter, owner: $owner) {
      id
      owner
      noticeID
      noticeViewed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserNotice = /* GraphQL */ `
  subscription OnDeleteUserNotice(
    $filter: ModelSubscriptionUserNoticeFilterInput
    $owner: String
  ) {
    onDeleteUserNotice(filter: $filter, owner: $owner) {
      id
      owner
      noticeID
      noticeViewed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateNoticeDescription = /* GraphQL */ `
  subscription OnCreateNoticeDescription(
    $filter: ModelSubscriptionNoticeDescriptionFilterInput
  ) {
    onCreateNoticeDescription(filter: $filter) {
      id
      noticeTitle
      noticeDescription
      noticeLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateNoticeDescription = /* GraphQL */ `
  subscription OnUpdateNoticeDescription(
    $filter: ModelSubscriptionNoticeDescriptionFilterInput
  ) {
    onUpdateNoticeDescription(filter: $filter) {
      id
      noticeTitle
      noticeDescription
      noticeLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteNoticeDescription = /* GraphQL */ `
  subscription OnDeleteNoticeDescription(
    $filter: ModelSubscriptionNoticeDescriptionFilterInput
  ) {
    onDeleteNoticeDescription(filter: $filter) {
      id
      noticeTitle
      noticeDescription
      noticeLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDeleteAccount = /* GraphQL */ `
  subscription OnCreateDeleteAccount(
    $filter: ModelSubscriptionDeleteAccountFilterInput
    $owner: String
  ) {
    onCreateDeleteAccount(filter: $filter, owner: $owner) {
      id
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDeleteAccount = /* GraphQL */ `
  subscription OnUpdateDeleteAccount(
    $filter: ModelSubscriptionDeleteAccountFilterInput
    $owner: String
  ) {
    onUpdateDeleteAccount(filter: $filter, owner: $owner) {
      id
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDeleteAccount = /* GraphQL */ `
  subscription OnDeleteDeleteAccount(
    $filter: ModelSubscriptionDeleteAccountFilterInput
    $owner: String
  ) {
    onDeleteDeleteAccount(filter: $filter, owner: $owner) {
      id
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateOrg = /* GraphQL */ `
  subscription OnCreateOrg(
    $filter: ModelSubscriptionOrgFilterInput
    $owner: String
  ) {
    onCreateOrg(filter: $filter, owner: $owner) {
      id
      owner
      haikuboxName
      lat
      lon
      tz
      publicDirectory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOrg = /* GraphQL */ `
  subscription OnUpdateOrg(
    $filter: ModelSubscriptionOrgFilterInput
    $owner: String
  ) {
    onUpdateOrg(filter: $filter, owner: $owner) {
      id
      owner
      haikuboxName
      lat
      lon
      tz
      publicDirectory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOrg = /* GraphQL */ `
  subscription OnDeleteOrg(
    $filter: ModelSubscriptionOrgFilterInput
    $owner: String
  ) {
    onDeleteOrg(filter: $filter, owner: $owner) {
      id
      owner
      haikuboxName
      lat
      lon
      tz
      publicDirectory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSubscription = /* GraphQL */ `
  subscription OnCreateSubscription(
    $filter: ModelSubscriptionSubscriptionFilterInput
    $owner: String
  ) {
    onCreateSubscription(filter: $filter, owner: $owner) {
      id
      owner
      stripeCustomer
      prepaidType
      prepaidPeriodEndUnix
      stripeCurrentPeriodEndUnix
      subscriptionId
      autoRenew
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSubscription = /* GraphQL */ `
  subscription OnUpdateSubscription(
    $filter: ModelSubscriptionSubscriptionFilterInput
    $owner: String
  ) {
    onUpdateSubscription(filter: $filter, owner: $owner) {
      id
      owner
      stripeCustomer
      prepaidType
      prepaidPeriodEndUnix
      stripeCurrentPeriodEndUnix
      subscriptionId
      autoRenew
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSubscription = /* GraphQL */ `
  subscription OnDeleteSubscription(
    $filter: ModelSubscriptionSubscriptionFilterInput
    $owner: String
  ) {
    onDeleteSubscription(filter: $filter, owner: $owner) {
      id
      owner
      stripeCustomer
      prepaidType
      prepaidPeriodEndUnix
      stripeCurrentPeriodEndUnix
      subscriptionId
      autoRenew
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSubscriptionHistory = /* GraphQL */ `
  subscription OnCreateSubscriptionHistory(
    $filter: ModelSubscriptionSubscriptionHistoryFilterInput
  ) {
    onCreateSubscriptionHistory(filter: $filter) {
      id
      owner
      serial
      eventType
      latestInvoice
      stripeCustomer
      subscriptionId
      autoRenew
      datePaidUnix
      unitAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSubscriptionHistory = /* GraphQL */ `
  subscription OnUpdateSubscriptionHistory(
    $filter: ModelSubscriptionSubscriptionHistoryFilterInput
  ) {
    onUpdateSubscriptionHistory(filter: $filter) {
      id
      owner
      serial
      eventType
      latestInvoice
      stripeCustomer
      subscriptionId
      autoRenew
      datePaidUnix
      unitAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSubscriptionHistory = /* GraphQL */ `
  subscription OnDeleteSubscriptionHistory(
    $filter: ModelSubscriptionSubscriptionHistoryFilterInput
  ) {
    onDeleteSubscriptionHistory(filter: $filter) {
      id
      owner
      serial
      eventType
      latestInvoice
      stripeCustomer
      subscriptionId
      autoRenew
      datePaidUnix
      unitAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateFavoriteHit = /* GraphQL */ `
  subscription OnCreateFavoriteHit(
    $filter: ModelSubscriptionFavoriteHitFilterInput
    $owner: String
  ) {
    onCreateFavoriteHit(filter: $filter, owner: $owner) {
      id
      serial
      owner
      dt
      animalGroup
      cn
      sn
      spCode
      wav
      score
      specSum
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateFavoriteHit = /* GraphQL */ `
  subscription OnUpdateFavoriteHit(
    $filter: ModelSubscriptionFavoriteHitFilterInput
    $owner: String
  ) {
    onUpdateFavoriteHit(filter: $filter, owner: $owner) {
      id
      serial
      owner
      dt
      animalGroup
      cn
      sn
      spCode
      wav
      score
      specSum
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteFavoriteHit = /* GraphQL */ `
  subscription OnDeleteFavoriteHit(
    $filter: ModelSubscriptionFavoriteHitFilterInput
    $owner: String
  ) {
    onDeleteFavoriteHit(filter: $filter, owner: $owner) {
      id
      serial
      owner
      dt
      animalGroup
      cn
      sn
      spCode
      wav
      score
      specSum
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserSettings = /* GraphQL */ `
  subscription OnCreateUserSettings(
    $filter: ModelSubscriptionUserSettingsFilterInput
    $owner: String
  ) {
    onCreateUserSettings(filter: $filter, owner: $owner) {
      id
      owner
      hidePics
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserSettings = /* GraphQL */ `
  subscription OnUpdateUserSettings(
    $filter: ModelSubscriptionUserSettingsFilterInput
    $owner: String
  ) {
    onUpdateUserSettings(filter: $filter, owner: $owner) {
      id
      owner
      hidePics
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserSettings = /* GraphQL */ `
  subscription OnDeleteUserSettings(
    $filter: ModelSubscriptionUserSettingsFilterInput
    $owner: String
  ) {
    onDeleteUserSettings(filter: $filter, owner: $owner) {
      id
      owner
      hidePics
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateOfflineApi = /* GraphQL */ `
  subscription OnCreateOfflineApi(
    $filter: ModelSubscriptionOfflineApiFilterInput
    $owner: String
  ) {
    onCreateOfflineApi(filter: $filter, owner: $owner) {
      id
      owner
      okey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOfflineApi = /* GraphQL */ `
  subscription OnUpdateOfflineApi(
    $filter: ModelSubscriptionOfflineApiFilterInput
    $owner: String
  ) {
    onUpdateOfflineApi(filter: $filter, owner: $owner) {
      id
      owner
      okey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOfflineApi = /* GraphQL */ `
  subscription OnDeleteOfflineApi(
    $filter: ModelSubscriptionOfflineApiFilterInput
    $owner: String
  ) {
    onDeleteOfflineApi(filter: $filter, owner: $owner) {
      id
      owner
      okey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTargetFirmware = /* GraphQL */ `
  subscription OnCreateTargetFirmware(
    $filter: ModelSubscriptionTargetFirmwareFilterInput
    $owner: String
  ) {
    onCreateTargetFirmware(filter: $filter, owner: $owner) {
      id
      owner
      deviceType
      net
      targetVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTargetFirmware = /* GraphQL */ `
  subscription OnUpdateTargetFirmware(
    $filter: ModelSubscriptionTargetFirmwareFilterInput
    $owner: String
  ) {
    onUpdateTargetFirmware(filter: $filter, owner: $owner) {
      id
      owner
      deviceType
      net
      targetVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTargetFirmware = /* GraphQL */ `
  subscription OnDeleteTargetFirmware(
    $filter: ModelSubscriptionTargetFirmwareFilterInput
    $owner: String
  ) {
    onDeleteTargetFirmware(filter: $filter, owner: $owner) {
      id
      owner
      deviceType
      net
      targetVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
